require('./carousel.css');
module.exports = require('./index-nocss.js');



//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-bootstrap/src/carousel/index.js
// module id = 467
// module chunks = 1